<template>
  <div>
    <div class="head">
      <el-breadcrumb style="margin-top:20px;margin-left:20px" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/processManager'}">风险分区管理</el-breadcrumb-item>
        <el-breadcrumb-item>两单管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content">
      <div class="content" style="height:80%">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="安全风险分级管控清单" name="first">
            <div style="display: flex;width: 100%;justify-content: space-between;margin-bottom: 2%">
              <Button type="primary" @click="handAdd1()">新建</Button>
              <Input
                search
                enter-button
                placeholder=" 请输入名称"
                v-model="findName"
                @on-search="getRiskClassification(1)"
                style="width: 300px"
              />
            </div>
            <Table border :columns="columns1" :data="data1" size="small">
              <template slot-scope="{ row }" slot="riskName">
                <el-link type="primary" @click="showDetailInfo(row,'a')">{{row.riskName}}</el-link>
              </template>
              <template slot-scope="{ row }" slot="riskType">
                <el-tag v-if="row.riskType == 0">固有风险</el-tag>
                <el-tag v-if="row.riskType == 1">作业风险</el-tag>
                <el-tag v-if="row.riskType == 2">设备风险</el-tag>
              </template>
              <template slot-scope="{ row }" slot="result">
                <div>
                  <span>
                    风险矩阵法：
                    <Tag color="error" v-if="row.riskMatrix == 0">重大风险</Tag>
                    <Tag color="#9D4D0b" v-if="row.riskMatrix == 1">较大风险</Tag>
                    <Tag color="warning" v-if="row.riskMatrix == 2">一般风险</Tag>
                    <Tag color="primary" v-if="row.riskMatrix == 3">低风险</Tag>
                    <Tag v-if="row.riskMatrix== null">未评价</Tag>
                  </span>
                </div>
                <div v-if=" row.riskType == 1">
                  <span>
                    作业条件危险性分析法：
                    <Tag color="error" v-if="row.riskAnalysis == 0">重大风险</Tag>
                    <Tag color="#9D4D0b" v-if="row.riskAnalysis == 1">较大风险</Tag>
                    <Tag color="warning" v-if="row.riskAnalysis == 2">一般风险</Tag>
                    <Tag color="primary" v-if="row.riskAnalysis == 3">低风险</Tag>
                    <Tag v-if="row.riskAnalysis== null">未评价</Tag>
                  </span>
                </div>
                <div v-if="row.riskType == 1 || row.riskType == 2">
                  <span>
                    风险程度分析法：
                    <Tag color="error" v-if="row.degreeAnalysis == 0">重大风险</Tag>
                    <Tag color="#9D4D0b" v-if="row.degreeAnalysis == 1">较大风险</Tag>
                    <Tag color="warning" v-if="row.degreeAnalysis == 2">一般风险</Tag>
                    <Tag color="primary" v-if="row.degreeAnalysis == 3">低风险</Tag>
                    <Tag v-if="row.degreeAnalysis== null">未评价</Tag>
                  </span>
                </div>
              </template>
              <template slot-scope="{ row }" slot="controlLevel">
                <Tag color="error" v-if="row.controlLevel == 0">重大风险</Tag>
                <Tag color="#9D4D0b" v-if="row.controlLevel == 1">较大风险</Tag>
                <Tag color="warning" v-if="row.controlLevel == 2">一般风险</Tag>
                <Tag color="primary" v-if="row.controlLevel == 3">低风险</Tag>
              </template>
              <template slot-scope="{ row }" slot="action">
                <el-link type="primary" size="small" @click="showModal(row)">风险评价</el-link>|
                <el-link type="primary" size="small" @click="showDetailInfo(row,'b')">审批</el-link>|
                <el-link type="primary" size="small" @click="showDetailInfo(row,'c')">报警记录</el-link>|
                <el-link type="primary" size="small" @click="edit1(row)">编辑</el-link>|
                <el-link type="danger" size="small" @click="remove1(row)">删除</el-link>
              </template>
            </Table>
            <div style="text-align: right; margin-top: 10px">
              <Page
                :total="total1"
                :page-size="pageSize"
                @on-change="getRiskClassification"
                :current="curPageGk"
              />
            </div>
          </el-tab-pane>
          <el-tab-pane label="危险(有害)因素排查辨识清单" name="second">
            <div style="display: flex;width: 100%;justify-content: space-between;margin-bottom: 2%">
              <Button type="primary" @click="handAdd2()">新建</Button>
              <el-select
                v-model="dangerAreaId"
                placeholder="请选择区域"
                clearable
                size="small"
                @change="getHarmfulfactors1"
              >
                <el-option
                  v-for="item in dangerAreas"
                  :key="item.id"
                  :label="item.cellName"
                  :value="item.id"
                ></el-option>
              </el-select>
              <Input
                search
                enter-button
                placeholder=" 请输入名称"
                v-model="name"
                @on-search="getHarmfulfactors(1)"
                style="width: 300px"
              />
            </div>
            <Table border :columns="columns2" :data="data2">
              <template slot-scope="{ row }" slot="action">
                <el-link type="primary" size="small" @click="edit2(row)">编辑</el-link>|
                <el-link type="danger" size="small" @click="remove2(row)">删除</el-link>
              </template>
            </Table>
            <div style="text-align: right; margin-top: 10px">
              <Page
                :total="total2"
                :page-size="pageSize"
                @on-change="getHarmfulfactors"
                :curren="curPagePC"
              />
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <template>
      <Modal v-model="modalShow" title="编辑评价记录" @on-ok="asyncOK">
        <el-form ref="assmentData" :model="assmentData" label-width="180px">
          <el-form-item label="风险矩阵法 LS：">
            <Tag color="error" v-if="assmentData.riskMatrix == 0">重大风险</Tag>
            <Tag color="#9D4D0b" v-if="assmentData.riskMatrix == 1">较大风险</Tag>
            <Tag color="warning" v-if="assmentData.riskMatrix == 2">一般风险</Tag>
            <Tag color="primary" v-if="assmentData.riskMatrix == 3">低风险</Tag>
            <Tag v-if="assmentData.riskMatrix == null">未评价</Tag>
            <el-button size="small" @click="showBigModal">评价</el-button>
          </el-form-item>
          <el-form-item
            label="风险程度分析法 MES： "
            v-if=" assmentData.riskType == 1 || assmentData.riskType == 2"
          >
            <Tag color="error" v-if="assmentData.degreeAnalysis == 0">重大风险</Tag>
            <Tag color="#9D4D0b" v-if="assmentData.degreeAnalysis == 1">较大风险</Tag>
            <Tag color="warning" v-if="assmentData.degreeAnalysis == 2">一般风险</Tag>
            <Tag color="primary" v-if="assmentData.degreeAnalysis == 3">低风险</Tag>
            <Tag v-if="assmentData.degreeAnalysis== null">未评价</Tag>
            <el-button size="small" @click="showBigModal2(2)">评价</el-button>
          </el-form-item>
          <el-form-item label="作业条件危险性分析法 LEC：" v-if=" assmentData.riskType == 1">
            <Tag color="error" v-if="assmentData.riskAnalysis == 0">重大风险</Tag>
            <Tag color="#9D4D0b" v-if="assmentData.riskAnalysis == 1">较大风险</Tag>
            <Tag color="warning" v-if="assmentData.riskAnalysis == 2">一般风险</Tag>
            <Tag color="primary" v-if="assmentData.riskAnalysis == 3">低风险</Tag>
            <Tag v-if="assmentData.riskAnalysis== null">未评价</Tag>
            <el-button size="small" @click="showBigModal2(1)">评价</el-button>
          </el-form-item>
          <el-form-item label="管控级别：">
            <el-select
              v-model="assmentData.controlLevel"
              placeholder="请选择"
              size="small"
              @change="changeControlLevel"
            >
              <el-option
                v-for="item in levelTypes"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="下次评价时间：">
            <el-date-picker
              size="small"
              v-model="assmentData.nextEvaluationTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="date"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
        </el-form>
      </Modal>
    </template>
    <template>
      <Modal fullscreen v-model="modalShowBig" title="编辑评价记录" @on-ok="asyncOK">
        <template>
          <Steps :current="current">
            <Step title="事故发生的可能性（L）"></Step>
            <Step title="事故后果的严重性（S）"></Step>
            <Step title="分析结果（R）"></Step>
          </Steps>
          <Table
            v-if="current == 0"
            border
            :columns="columns3"
            :data="data3"
            style="margin-top: 1%"
          >
            <template slot-scope="{ row, index }" slot="action">
              <InputNumber :max="4" :min="0" v-model="numl[index]" style="margin-left: -12%"></InputNumber>
            </template>
          </Table>
          <Table
            v-if="current == 1"
            border
            :columns="columns4"
            :data="data4"
            style="margin-top: 1%"
          >
            <template slot-scope="{ row, index }" slot="action">
              <InputNumber :max="4" :min="0" v-model="nums[index]" style="margin-left: -12%"></InputNumber>
            </template>
          </Table>
          <Table
            v-if="current == 2"
            border
            :columns="columns5"
            :data="data5"
            style="margin-top: 1%"
            :span-method="handleSpan"
          ></Table>
          <div v-if="current == 2" style="margin-left: 2%;margin-top: 1%;">
            <div>风险（R）计算：风险（R）= 事故发生的可能性（L）× 事故后果的严重性（S）</div>
            <div>
              <span>风险等级判别标准：</span>
              <ul style="margin-left: 3%">
                <li>R=1，2，3，蓝色低风险企业</li>
                <li>R=4，6，黄色一般风险企业</li>
                <li>R=8，9，橙色较大风险企业</li>
                <li>R=12，16，红色重大风险企业</li>
              </ul>
            </div>
            <div style="margin-top: 2%;font-size: 18px;">
              当前计算结果: L= {{l}}，S={{s}}， R = L * S = {{result}}
              <Tag color="primary" v-if="result <4">低风险</Tag>
              <Tag color="warning" v-if="result <=8 && result >=4">一般风险</Tag>
              <Tag color="#9D4D0b" v-if="result <=12 && result >8">较大风险</Tag>
              <Tag color="error" v-if="result >12 ">重大风险</Tag>
            </div>
          </div>
        </template>
        <div slot="footer">
          <div style="margin-left: 1%;float: left">
            <Button :disabled="current == 0" type="primary" @click="pre">上一步</Button>
            <Button :disabled="current == 2" type="primary" @click="next">下一步</Button>
          </div>
          <div style="margin-left: 1%;float: right">
            <Button @click="cancel">取消</Button>
            <Button type="primary" @click="asyncFinish">确定</Button>
          </div>
        </div>
      </Modal>
    </template>
    <template>
      <Modal fullscreen v-model="modalShowBig2" title="编辑评价记录" @on-ok="asyncOK2">
        <template>
          <Table border :columns="columns6" :data="data6" style="margin-top: 1%">
            <template slot-scope="{ row }" slot="col3">
              <el-tag v-for="(item,index) in row.col3" :key="index">{{item}}</el-tag>
            </template>
            <template slot-scope="{ row }" slot="col4">
              <el-tag v-for="(item,index) in row.col4" :key="index">{{item}}</el-tag>
            </template>
            <template slot-scope="{ row, index }" slot="col10">
              <InputNumber
                :max="5"
                :min="0"
                v-model="numl2[index]"
                style="margin-left: -12%"
                @on-change="changeNum"
              ></InputNumber>
            </template>
            <template slot-scope="{ row, index }" slot="col11">
              <InputNumber
                :max="5"
                :min="0"
                v-model="nums2[index]"
                style="margin-left: -12%"
                @on-change="changeNum"
              ></InputNumber>
            </template>
          </Table>
        </template>
      </Modal>
    </template>
    <template>
      <Modal fullscreen v-model="modalShowBig3" title="编辑评价记录" @on-ok="asyncOK3">
        <template>
          <Table border :columns="columns7" :data="data7" style="margin-top: 1%">
            <template slot-scope="{ row }" slot="col3">
              <el-tag v-for="(item,index) in row.col3" :key="index">{{item}}</el-tag>
            </template>
            <template slot-scope="{ row }" slot="col4">
              <el-tag v-for="(item,index) in row.col4" :key="index">{{item}}</el-tag>
            </template>
            <template slot-scope="{ row, index }" slot="col15">
              <InputNumber
                :max="5"
                :min="0"
                v-model="numm3[index]"
                style="margin-left: -12%"
                @on-change="changeNum2"
              ></InputNumber>
            </template>
            <template slot-scope="{ row, index }" slot="col11">
              <InputNumber
                :max="10"
                :min="0"
                v-model="nums3[index]"
                style="margin-left: -12%"
                @on-change="changeNum2"
              ></InputNumber>
            </template>
            <template slot-scope="{ row, index }" slot="col16">
              <InputNumber
                :max="10"
                :min="0"
                v-model="nume3[index]"
                style="margin-left: -12%"
                @on-change="changeNum2"
              ></InputNumber>
            </template>
          </Table>
        </template>
      </Modal>
    </template>
    <template>
      <el-drawer :visible.sync="drawer" direction="rtl" :before-close="handleClose" size="83%">
        <span slot="title">
          <div style="margin-left: 1%">
            <span style="font-size: 20px">
              <b>{{showData.riskName}}</b>
            </span>
          </div>
          <div style="margin-top: 1%;margin-left: 1%">
            <el-row :gutter="20">
              <el-col :span="6">
                <div class="grid-content bg-purple">
                  <b>类型</b>
                </div>
                <div class="grid-content bg-purple" style="margin-top: 3%">
                  <el-tag v-if="showData.riskType == 0">固有风险</el-tag>
                  <el-tag v-if="showData.riskType == 1">作业风险</el-tag>
                  <el-tag v-if="showData.riskType == 2">设备风险</el-tag>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content bg-purple">
                  <b>风险等级</b>
                </div>
                <div class="grid-content bg-purple" style="margin-top: 3%">
                  <Tag color="error" v-if="showData.controlLevel == 0">重大风险</Tag>
                  <Tag color="#9D4D0b" v-if="showData.controlLevel == 1">较大风险</Tag>
                  <Tag color="warning" v-if="showData.controlLevel == 2">一般风险</Tag>
                  <Tag color="primary" v-if="showData.controlLevel == 3">低风险</Tag>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content bg-purple">
                  <b>创建时间</b>
                </div>
                <div class="grid-content bg-purple" style="margin-top: 3%">{{showData.gmtCreate}}</div>
              </el-col>
            </el-row>
          </div>
        </span>
        <div style="background-color: white;height: 95%;margin-top: 1%">
          <el-tabs v-model="currentActive" type="border-card">
            <el-tab-pane label="详情" name="a">
              <el-form
                :model="showData"
                style="background-color: white;text-align: left;overflow:auto;height: 400px"
              >
                <el-form-item label="区域：" style="width: 40%;margin-left: 8%">
                  <span size="small">{{showData.dangerAreaName}}</span>
                </el-form-item>

                <el-form-item label="风险点名称：" style="width: 40%;margin-left: 8%">
                  <span size="small">{{showData.riskName}}</span>
                </el-form-item>
                <el-form-item label="风险具体位置：" style="width: 40%;margin-left: 8%">
                  <el-tag v-if="showData.riskType == 0">固有风险</el-tag>
                  <el-tag v-if="showData.riskType == 1">作业风险</el-tag>
                  <el-tag v-if="showData.riskType == 2">设备风险</el-tag>
                </el-form-item>
                <el-form-item
                  v-if="showData.riskType == 0"
                  label="危险源或潜在事件："
                  style="width: 40%;margin-left: 8%"
                >
                  <span size="small">{{showData.hazardOrPotentialEvent}}</span>
                </el-form-item>
                <el-form-item
                  v-if="showData.riskType == 0"
                  label="发生事故类型："
                  style="width: 40%;margin-left: 8%"
                >
                  <span size="small">{{showData.accidentType}}</span>
                </el-form-item>
                <el-form-item
                  v-if="showData.riskType == 0"
                  label="应急处置："
                  style="width: 40%;margin-left: 8%"
                >
                  <span size="small">{{showData.emergencyResponse}}</span>
                </el-form-item>
                <el-form-item label="提案人：" style="width: 40%;margin-left: 8%">
                  <span size="small">{{showData.proposerName}}</span>
                </el-form-item>
                <el-form-item label="审批人：" style="width: 40%;margin-left: 8%">
                  <span size="small">{{showData.approverName}}</span>
                </el-form-item>
                <el-form-item label="执行人：" style="width: 40%;margin-left: 8%">
                  <span size="small">{{showData.executorName}}</span>
                </el-form-item>
                <el-form-item label="复核人：" style="width: 40%;margin-left: 8%">
                  <span size="small">{{showData.reviewerName}}</span>
                </el-form-item>
                <el-form-item label="负责人：" style="width: 40%;margin-left: 8%">
                  <span size="small">{{showData.principalName}}</span>
                </el-form-item>
              </el-form>
              <!-- 右边抽屉详情tab栏下面的表格  固有风险不显示 -->
              <el-table v-if="showData.riskType != 0" :data="showData.content" style="width: 100%">
                <el-table-column label="序号" prop="col1"></el-table-column>
                <el-table-column label="作业步骤" prop="col2"></el-table-column>
                <el-table-column label="现有控制措施">
                  <el-table-column label="工程技术措施" prop="col5"></el-table-column>
                  <el-table-column label="管理措施" prop="col6"></el-table-column>
                  <el-table-column label="培训教育措施" prop="col7"></el-table-column>
                  <el-table-column label="个体防护措施" prop="col8"></el-table-column>
                  <el-table-column label="应急处置措施" prop="col9"></el-table-column>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="管控跟踪" name="b">
              <Steps :current="step">
                <Step title="提案" :content="showData.proposerName"></Step>
                <Step title="审批" :content="showData.approverName"></Step>
                <Step title="执行" :content="showData.executorName"></Step>
                <Step title="复核" :content="showData.reviewerName"></Step>
              </Steps>
              <el-form
                v-if="showData.status == 0 && myId == showData.proposer"
                :model="proposerconData"
                label-width="150px"
                style="background-color: white;text-align: left;overflow:auto;height: 400px;margin-top: 2%"
              >
                <el-form-item label="管控措施类别：" style="width: 40%;margin-left: 8%">
                  <el-select
                    v-model="proposerconData.type"
                    placeholder="请选择"
                    size="small"
                    style="width:500px"
                  >
                    <el-option
                      v-for="item in proposerTypes"
                      :key="item.id"
                      :label="item.name"
                      :value="item.name"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="具体管控措施：" style="width: 40%;margin-left: 8%">
                  <el-input
                    style="width:500px"
                    type="textarea"
                    v-model="proposerconData.context"
                    size="small"
                  ></el-input>
                </el-form-item>
                <el-form-item label="责任单位：" style="width: 40%;margin-left: 8%">
                  <el-input style="width:500px" v-model="proposerconData.company" size="small"></el-input>
                </el-form-item>
                <el-form-item label="责任人：" style="width: 40%;margin-left: 8%">
                  <el-input style="width:500px" v-model="proposerconData.people" size="small"></el-input>
                </el-form-item>
                <el-form-item label="整改投入资金：" style="width: 40%;margin-left: 8%">
                  <InputNumber v-model="proposerconData.money" size="small"></InputNumber>
                </el-form-item>
                <Button style="margin-left: 42%" @click="submitProposer">提交</Button>
              </el-form>
              <el-form
                v-if="showData.status == 1 && myId == showData.approver"
                :model="approverData"
                label-width="150px"
                style="background-color: white;text-align: left;overflow:auto;height: 400px;margin-top: 2%"
              >
                <el-form-item label="审批：" style="width: 40%;margin-left: 8%">
                  <el-select
                    v-model="approverData.type"
                    placeholder="请选择"
                    size="small"
                    style="width:500px"
                  >
                    <el-option
                      v-for="item in approverTypes"
                      :key="item.id"
                      :label="item.name"
                      :value="item.name"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="审批意见：" style="width: 40%;margin-left: 8%">
                  <el-input
                    style="width:500px"
                    type="textarea"
                    v-model="approverData.context"
                    size="small"
                  ></el-input>
                </el-form-item>

                <Button style="margin-left: 42%" @click="submitApprover">提交</Button>
              </el-form>
              <el-form
                v-if="showData.status == 2 && myId == showData.executor"
                :model="executorData"
                label-width="150px"
                style="background-color: white;text-align: left;overflow:auto;height: 400px;margin-top: 2%"
              >
                <el-form-item label="审批：" style="width: 40%;margin-left: 8%">
                  <el-date-picker
                    size="small"
                    v-model="executorData.time"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="审批意见：" style="width: 40%;margin-left: 8%">
                  <el-input
                    style="width:500px"
                    type="textarea"
                    v-model="executorData.context"
                    size="small"
                  ></el-input>
                </el-form-item>

                <Button style="margin-left: 42%" @click="submitExecutor">提交</Button>
              </el-form>
              <el-form
                v-if="showData.status == 3 && myId == showData.reviewer"
                :model="reviewerData"
                label-width="150px"
                style="background-color: white;text-align: left;overflow:auto;height: 400px;margin-top: 2%"
              >
                <el-form-item label="复审状态：" style="width: 40%;margin-left: 8%">
                  <el-select
                    v-model="reviewerData.type"
                    placeholder="请选择"
                    size="small"
                    style="width:500px"
                  >
                    <el-option
                      v-for="item in reviewerTypes"
                      :key="item.id"
                      :label="item.name"
                      :value="item.name"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="复审意见：" style="width: 40%;margin-left: 8%">
                  <el-input
                    style="width:500px"
                    type="textarea"
                    v-model="reviewerData.context"
                    size="small"
                  ></el-input>
                </el-form-item>

                <Button style="margin-left: 42%" @click="submitReviewer">提交</Button>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="报警记录" name="c">
              <template>
                <el-table :data="alarmRecord" border style="width: 100%">
                  <el-table-column prop="name" label="名称"></el-table-column>
                  <el-table-column prop="dealContent" label="内容"></el-table-column>
                  <el-table-column prop="because" label="原因"></el-table-column>
                  <el-table-column prop="dealContent" label="处理结果"></el-table-column>
                  <el-table-column prop="dealTime" label="处理时间"></el-table-column>
                  <el-table-column prop="nickname" label="处理人"></el-table-column>
                  <el-table-column prop="isDeal" label="状态">
                    <template slot-scope="{row}">{{row.isDeal === 1 ? "已处理" : "未处理"}}</template>
                  </el-table-column>
                  <el-table-column prop="channelTime" label="报警时间"></el-table-column>
                </el-table>
              </template>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-drawer>
    </template>
  </div>
</template>

<script>
import {
  jumpTwoOrder,
  getDangerISPcList,
  getAlarmRecordList
} from "@/api/processManager";
export default {
  data() {
    return {
      name: "",
      dangerAreas: [],
      reviewerTypes: [
        { id: 0, name: "通过" },
        { id: 1, name: "不通过" }
      ],
      reviewerData: {},
      executorData: {},
      approverData: {},
      approverTypes: [
        { id: 0, name: "通过" },
        { id: 1, name: "不通过" }
      ],
      proposerTypes: [
        { id: 0, name: "工程技术措施" },
        { id: 1, name: "管理措施" },
        { id: 2, name: "安全教育措施" },
        { id: 3, name: "个体防护措施" },
        { id: 4, name: "应急处置措施" }
      ],
      proposerconData: {},
      step: 0,
      alarmRecord: [],
      locationName: "",
      riskLocations: [
        { id: "1", name: "127.0.0.1:9999" },
        { id: "2", name: "127.0.0.1:8087" },
        { id: "3", name: "127.0.0.1:8882" },
        { id: "4", name: "127.0.0.1:8080" }
      ],
      showData: {},
      currentActive: "a",
      drawer: false,
      numm3: [],
      nums3: [],
      nume3: [],
      riskNum: 0,
      numl2: [],
      nums2: [],
      numl: [0, 0, 0, 0, 0, 0],
      nums: [0, 0, 0, 0, 0, 0],
      result: 0,
      l: 0,
      s: 0,
      current: 0,
      modalShowBig: false,
      modalShowBig2: false,
      modalShowBig3: false,
      assmentData: {},
      modalShow: false,
      pageSize: 10,
      findName: "",
      activeName: "first",
      dangerAreaId: "",
      total1: 0,
      total2: 0,
      levelTypes: [
        { id: 0, name: "重大风险" },
        { id: 1, name: "较大风险" },
        { id: 2, name: "一般风险" },
        { id: 3, name: "低风险" }
      ],
      columns1: [
        { title: "风险点名称", slot: "riskName", align: "center" },
        { title: "类型", slot: "riskType", align: "center", width: 100 },
        { title: "区域", key: "dangerAreaName", align: "center" },
        { title: "评价结果", slot: "result", align: "left", width: 200 },
        { title: "管控级别", slot: "controlLevel", align: "center" },
        { title: "创建时间", key: "gmtCreate", align: "center" },
        { title: "下次评价时间", key: "nextEvaluationTime", align: "center" },
        { title: "操作", slot: "action", width: 200, align: "center" }
      ],
      data1: [],
      columns2: [
        { title: "名称", key: "name", align: "center" },
        {
          title: "存在的主要危险（有害）因素",
          align: "center",
          children: [
            {
              title: "代码",
              key: "harmfulCode",
              align: "center",
              width: 100
            },
            {
              title: "名称",
              key: "harmfulName",
              align: "center",
              width: 150,
              tooltip: true
            }
          ]
        },
        {
          title: "易发生事故类型",
          key: "accdientType",
          width: 200,
          align: "center",
          tooltip: true
        },
        { title: "填表人", key: "filler", width: 80, align: "center" },
        { title: "负责人", key: "chargePerson", width: 80, align: "center" },
        { title: "排查日期", key: "investigationDate" },
        { title: "创建时间", key: "gmtCreate" },
        { title: "最近修改时间", key: "gmtModified" },
        { title: "操作", slot: "action", width: 130, align: "center" }
      ],
      data2: [],
      columns3: [
        { title: "序号", key: "col1", align: "center", width: 50 },
        { title: "项目", key: "col2", align: "center" },
        {
          title: "取值标准",
          align: "center",
          children: [
            {
              title: "1",
              key: "col3",
              align: "center"
            },
            {
              title: "2",
              key: "col4",
              align: "center"
            },
            {
              title: "3",
              key: "col5",
              align: "center"
            },
            {
              title: "4",
              key: "col6",
              align: "center"
            }
          ]
        },
        { title: "Ln", key: "col7", width: 80, align: "center" },
        { title: "L", slot: "action", width: 100, align: "center" }
      ],
      data3: [
        {
          col1: "1",
          col2: "生产装置火灾危险性类别",
          col3: "丙类（不含丙类）以下",
          col4: "丙类",
          col5: "乙类",
          col6: "甲类",
          col7: "L1",
          col8: 0
        },
        {
          col1: "2",
          col2: "化学品急性毒性危害类别",
          col3: "类别4、类别5",
          col4: "类别3",
          col5: "类别2",
          col6: "类别1",
          col7: "L2",
          col8: 0
        },
        {
          col1: "3",
          col2: "危险工艺和重点监管危险化学品",
          col3:
            "（1）不涉及重点监管危险化学品且不涉及危险工艺和金属有机物合成反应（包括格氏反应）。 （2）精细化工反应工艺安全风险已经反应安全风险评估。 （3）国内首次采用的化工工艺已经安全可靠性论证。 （4）除上述外的其他工艺。",
          col4:
            "涉及重点监管危险化学品但不涉及危险工艺和金属有机物合成反应（包括格氏反应）。",
          col5:
            "不涉及重点监管危险化学品但涉及危险工艺和金属有机物合成反应（包括格氏反应）。",
          col6:
            "（1）涉及重点监管危险化学品且涉及危险工艺或金属有机物合成反应（包括格氏反应）。 （2）精细化工反应工艺安全风险未经反应安全风险评估。 （3）国内首次采用的化工工艺未经安全可靠性论证。",
          col7: "L3",
          col8: 0
        },
        {
          col1: "4",
          col2: "工艺压力(p)",
          col3: "p≤0.1MPa",
          col4: "0.1MPa＜p＜1.6MPa",
          col5: "1.6MPa≤p＜10.0MPa",
          col6: "p≥10.0Mpa",
          col7: "L4",
          col8: 0
        },
        {
          col1: "5",
          col2: "工艺温度（t）",
          col3: "t≤20℃",
          col4: "20℃＜t＜150℃",
          col5: "150℃≤t＜450℃",
          col6: "t≥450℃",
          col7: "L5",
          col8: 0
        },
        {
          col1: "6",
          col2: "重大生产安全事故隐患",
          col3: "",
          col4: "",
          col5: "",
          col6:
            "存在《化工和危险化学品生产经营单位重大生产安全事故隐患判定标准（试行）》中规定的重大生产安全事故隐患",
          col7: "L6",
          col8: 0
        }
      ],
      columns4: [
        { title: "序号", key: "col1", align: "center", width: 50 },
        { title: "项目", key: "col2", align: "center" },
        {
          title: "取值标准",
          align: "center",
          children: [
            {
              title: "1",
              key: "col3",
              align: "center"
            },
            {
              title: "2",
              key: "col4",
              align: "center"
            },
            {
              title: "3",
              key: "col5",
              align: "center"
            },
            {
              title: "4",
              key: "col6",
              align: "center"
            }
          ]
        },
        { title: "Sn", key: "col7", width: 80, align: "center" },
        { title: "S", slot: "action", width: 100, align: "center" }
      ],
      data4: [
        {
          col1: "1",
          col2:
            "评估区域与周边相邻的不符合防火间距要求的其他区域（包括周边企业）现场人数之和",
          col3: "0-2人",
          col4: "3-9人",
          col5: "10-29人",
          col6: "30人及以上",
          col7: "S1",
          col8: 0
        },
        {
          col1: "2",
          col2: "评估区域与周边相邻其他区域（包括周边企业）现场人数的最大值",
          col3: "0-2人",
          col4: "3-9人",
          col5: "10-29人",
          col6: "30人及以上",
          col7: "S2",
          col8: 0
        },
        {
          col1: "3",
          col2: "所在企业任一装置设施类区域最大现场人数",
          col3: "0-2人",
          col4: "3-9人",
          col5: "10-29人",
          col6: "30人及以上",
          col7: "S3",
          col8: 0
        },
        {
          col1: "4",
          col2: "评估区域重大危险源等级",
          col3: "非重大危险源",
          col4: "三、四级",
          col5: "二级",
          col6: "一级",
          col7: "S4",
          col8: 0
        },
        {
          col1: "5",
          col2: "企业边界外500米范围内",
          col3: "无或有1个低密度人员场所",
          col4: "有居住类高密度场所或公众聚集类高密度场所",
          col5: "有1个高敏感场所、重要防护目标或特殊高密度场所",
          col6: "有2个及以上高敏感场所、重要防护目标或特殊高密度场所",
          col7: "S5",
          col8: 0
        }
      ],
      columns5: [
        {
          title: "风险矩阵（R）",
          align: "center",
          children: [
            {
              key: "col1",
              align: "center"
            },
            {
              key: "col2",
              align: "center"
            }
          ]
        },
        {
          title: "事故后果的严重性（S）",
          align: "center",
          children: [
            {
              title: "1",
              key: "col3",
              align: "center"
            },
            {
              title: "2",
              key: "col4",
              align: "center"
            },
            {
              title: "3",
              key: "col5",
              align: "center"
            },
            {
              title: "4",
              key: "col6",
              align: "center"
            }
          ]
        }
      ],
      data5: [
        {
          col1: "事故发生的可能性（L）",
          col2: "1",
          col3: "",
          col4: "",
          col5: "",
          col6: "",
          cellClassName: {
            col3: "myBlue",
            col4: "myBlue",
            col5: "myBlue",
            col6: "myYellow"
          }
        },
        {
          col1: "事故发生的可能性（L）",
          col2: "2",
          col3: "",
          col4: "",
          col5: "",
          col6: "",
          cellClassName: {
            col3: "myBlue",
            col4: "myYellow",
            col5: "myYellow",
            col6: "myNotRed"
          }
        },
        {
          col1: "事故发生的可能性（L）",
          col2: "3",
          col3: "",
          col4: "",
          col5: "",
          col6: "",
          cellClassName: {
            col3: "myBlue",
            col4: "myYellow",
            col5: "myNotRed",
            col6: "myRed"
          }
        },
        {
          col1: "事故发生的可能性（L）",
          col2: "4",
          col3: "",
          col4: "",
          col5: "",
          col6: "",
          cellClassName: {
            col3: "myBlue",
            col4: "myNotRed",
            col5: "myRed",
            col6: "myRed"
          }
        }
      ],
      columns6: [
        { title: "序号", key: "col1", align: "center", width: 50 },
        { title: "设备名称", key: "col2", align: "center" },
        { title: "风险源或潜在事件", slot: "col3", align: "center" },
        { title: "事故类型", slot: "col4", align: "center" },
        {
          title: "现有控制措施",
          align: "center",
          children: [
            {
              title: "工程技术措施",
              key: "col5",
              align: "center"
            },
            {
              title: "管理措施",
              key: "col6",
              align: "center"
            },
            {
              title: "培训教育措施",
              key: "col7",
              align: "center"
            },
            {
              title: "个体防护措施",
              key: "col8",
              align: "center"
            },
            {
              title: "应急处置措施",
              key: "col9",
              align: "center"
            }
          ]
        },
        {
          title: "风险评价",
          align: "center",
          children: [
            {
              title: "可能性（L）",
              slot: "col10",
              width: 130,
              align: "center"
            },
            {
              title: "严重性（S）",
              slot: "col11",
              width: 130,
              align: "center"
            },
            { title: "风险值", key: "col12", width: 80, align: "center" },
            { title: "评价级别", key: "col13", width: 80, align: "center" }
          ]
        },

        { title: "风险分级", key: "col14", width: 80, align: "center" }
      ],
      data6: [],
      columns7: [
        { title: "序号", key: "col1", align: "center", width: 50 },
        { title: "设备名称", key: "col2", align: "center" },
        { title: "风险源或潜在事件", slot: "col3", align: "center" },
        { title: "事故类型", slot: "col4", align: "center" },
        {
          title: "现有控制措施",
          align: "center",
          children: [
            {
              title: "工程技术措施",
              key: "col5",
              align: "center"
            },
            {
              title: "管理措施",
              key: "col6",
              align: "center"
            },
            {
              title: "培训教育措施",
              key: "col7",
              align: "center"
            },
            {
              title: "个体防护措施",
              key: "col8",
              align: "center"
            },
            {
              title: "应急处置措施",
              key: "col9",
              align: "center"
            }
          ]
        },
        { title: "状态（M）", slot: "col15", width: 130, align: "center" },
        { title: "严重性（S）", slot: "col11", width: 130, align: "center" },
        { title: "频次（E）", slot: "col16", width: 130, align: "center" },
        { title: "风险值", key: "col12", width: 80, align: "center" },
        { title: "评价级别", key: "col13", width: 80, align: "center" },
        { title: "风险分级", key: "col14", width: 80, align: "center" }
      ],
      data7: [],
      opType: 0,
      isShowOpe: false,
      myId: "",
      queryState: false,
      curPageGk: 1,
      curPagePC: 1
    };
  },
  methods: {
    // 点击标签页切换的事件
    handleClick(tab) {
      if (tab.index === "1") {
        this.getHarmfulfactors(1);
      }
    },
    getDangerArea() {
      let url = "/dangerinfo/list_all?limit=" + 500 + "&curPage=" + 1;
      this.componentsMoudel.httpRequest
        .getRequestHander(url)
        .openLoad()
        .startGet()
        .then(res => {
          this.dangerAreas = res.body.data;
        });
    },
    submitReviewer() {
      this.showData.status = 4;
      // this.showData.reviewercontext = JSON.stringify(this.reviewerData);
      let obj = { ...this.showData };
      obj.reviewercontext = JSON.stringify(this.reviewerData);
      obj.content = JSON.stringify(this.showData.content);
      this.componentsMoudel.httpRequest
        .getRequestHander("/riskclassification/update")
        .openLoad()
        .startPost(obj)
        .then(res => {
          if (res.result == "success") {
            this.$message({
              showClose: true,
              message: "提交成功",
              type: "success"
            });
            this.step = 3;
          }
        });
    },

    submitExecutor() {
      this.showData.status = 3;
      // this.showData.executorcontext = JSON.stringify(this.executorData);
      let obj = { ...this.showData };
      obj.executorcontext = JSON.stringify(this.executorData);
      obj.content = JSON.stringify(this.showData.content);
      this.componentsMoudel.httpRequest
        .getRequestHander("/riskclassification/update")
        .openLoad()
        .startPost(obj)
        .then(res => {
          if (res.result == "success") {
            this.$message({
              showClose: true,
              message: "提交成功",
              type: "success"
            });
            this.step = 3;
          }
        });
    },
    submitApprover() {
      this.showData.status = 2;
      // this.showData.approvercontext = JSON.stringify(this.approverData);
      let obj = { ...this.showData };
      obj.approvercontext = JSON.stringify(this.approverData);
      obj.content = JSON.stringify(this.showData.content);
      this.componentsMoudel.httpRequest
        .getRequestHander("/riskclassification/update")
        .openLoad()
        .startPost(obj)
        .then(res => {
          if (res.result == "success") {
            this.$message({
              showClose: true,
              message: "提交成功",
              type: "success"
            });
            this.step = 2;
          }
        });
    },
    submitProposer() {
      this.showData.status = 1;
      // this.showData.proposercontext = JSON.stringify(this.proposerconData);
      let obj = { ...this.showData };
      obj.proposercontext = JSON.stringify(this.proposerconData);
      obj.content = JSON.stringify(this.showData.content);
      this.componentsMoudel.httpRequest
        .getRequestHander("/riskclassification/update")
        .openLoad()
        .startPost(obj)
        .then(res => {
          if (res.result == "success") {
            this.$message({
              showClose: true,
              message: "提交成功",
              type: "success"
            });
            this.step = 1;
          }
        });
    },
    showDetailInfo(row, currentActive) {
      this.showData = row;
      if (typeof row.content === "string" && row.content) {
        this.showData.content = JSON.parse(row.content);
      }
      for (var i = 0; i < this.riskLocations.length; i++) {
        var riskLocation = this.riskLocations[i];
        if (riskLocation.id == this.showData.riskLocation) {
          this.locationName = riskLocation.name;
        }
      }
      // console.log(row)
      if (row.alarmId) {
        getAlarmRecordList({ ids: row.alarmId, limit: 10, curPage: 1 }).then(
          res => {
            this.alarmRecord = res.body.data;
          }
        );
      } else {
        this.alarmRecord = [];
      }
      this.currentActive = currentActive;
      this.drawer = true;
      this.step = this.showData.status;
    },
    getMyId() {
      const that = this;
      this.componentsMoudel
        .getRequestHander(this.componentsMoudel.getData("urls").userInfo)
        .startGet()
        .then(res => {
          this.myId = res.body.data.id;
        });
    },
    handleClose() {
      this.drawer = false;
    },
    changeNum2() {
      for (var i = 0; i < this.numm3.length; i++) {
        var l1 = this.numm3[i];
        var s1 = this.nums3[i];
        var e1 = this.nume3[i];
        this.data7[i].col12 = l1 * s1 * e1;
        if (this.data7[i].col12 <= 45) {
          this.data7[i].col13 = "轻度危险";
          this.data7[i].col14 = "低风险";
        }
        if (this.data7[i].col12 > 45 && this.data7[i].col12 < 100) {
          this.data7[i].col13 = "显著危险";
          this.data7[i].col14 = "一般风险";
        }
        if (this.data7[i].col12 > 100 && this.data7[i].col12 < 200) {
          this.data7[i].col13 = "高度危险";
          this.data7[i].col14 = "较大风险";
        }
        if (this.data7[i].col12 >= 200) {
          this.data7[i].col13 = "极其危险";
          this.data7[i].col14 = "重大风险";
        }
      }
      this.data7 = this.data7;
    },
    changeNum() {
      for (var i = 0; i < this.numl2.length; i++) {
        var l1 = this.numl2[i];
        var s1 = this.nums2[i];
        this.data6[i].col12 = l1 * s1;
        if (this.data6[i].col12 < 9) {
          this.data6[i].col13 = "轻度危险";
          this.data6[i].col14 = "低风险";
        }
        if (this.data6[i].col12 >= 9 && this.data6[i].col12 <= 12) {
          this.data6[i].col13 = "显著危险";
          this.data6[i].col14 = "一般风险";
        }
        if (this.data6[i].col12 > 12 && this.data6[i].col12 < 20) {
          this.data6[i].col13 = "高度危险";
          this.data6[i].col14 = "较大风险";
        }
        if (this.data6[i].col12 >= 20) {
          this.data6[i].col13 = "极其危险";
          this.data6[i].col14 = "重大风险";
        }
      }
      this.data6 = this.data6;
    },
    showBigModal2(type) {
      this.opType = type;
      // var l1 = this.numm3[i];
      // var s1 = this.nums3[i];
      // var e1 = this.nume3[i];
      this.modalShowBig3 = true;
      this.data7 = JSON.parse(this.assmentData.content);
      for (var i = 0; i < this.data7.length; i++) {
        var data6Element = this.data7[i];
        if (!data6Element.col15) {
          this.numm3[i] = 0;
        } else {
          this.numm3[i] = data6Element.col15;
        }
        if (!data6Element.col11) {
          this.nums3[i] = 0;
        } else {
          this.nums3[i] = data6Element.col11;
        }
        if (!data6Element.col16) {
          this.nume3[i] = 0;
        } else {
          this.nume3[i] = data6Element.col16;
        }
        this.changeNum2();
      }
    },
    showBigModal3() {},
    asyncOK3() {
      let status = 4;
      for (var i = 0; i < this.data7.length; i++) {
        var data6Element = this.data7[i];
        let cur = 0;
        if (data6Element.col14 == "低风险") {
          cur = 3;
        }
        if (data6Element.col14 == "一般风险") {
          cur = 2;
        }
        if (data6Element.col14 == "较大风险") {
          cur = 1;
        }
        if (data6Element.col14 == "重大风险") {
          cur = 0;
        }
        if (status > cur) {
          status = cur;
        }
        data6Element.col15 = this.numm3[i];
        data6Element.col11 = this.nums3[i];
        data6Element.col16 = this.nume3[i];
      }
      if (this.assmentData.riskType == 2) {
        this.assmentData.degreeAnalysis = status;
      }
      if (this.assmentData.riskType == 1) {
        if (this.opType == 1) {
          this.assmentData.riskAnalysis = status;
        } else if (this.opType == 2) {
          this.assmentData.degreeAnalysis = status;
        }
      }
      this.assmentData.content = JSON.stringify(this.data7);
    },
    asyncOK2() {
      let status = 4;
      for (var i = 0; i < this.data6.length; i++) {
        var data6Element = this.data6[i];
        let cur = 0;
        if (data6Element.col14 == "低风险") {
          cur = 3;
        }
        if (data6Element.col14 == "一般风险") {
          cur = 2;
        }
        if (data6Element.col14 == "较大风险") {
          cur = 1;
        }
        if (data6Element.col14 == "重大风险") {
          cur = 0;
        }
        if (status > cur) {
          status = cur;
        }
        data6Element.col10 = this.numl2[i];
        data6Element.col11 = this.nums2[i];
      }
      this.assmentData.riskMatrix = status;
      this.assmentData.content = JSON.stringify(this.data6);
    },
    asyncFinish() {
      let level = 5;
      if (this.result < 4) {
        level = 3;
      } else if (this.result < 8 && this.result >= 4) {
        level = 2;
      } else if (this.result < 12 && this.result >= 8) {
        level = 1;
      } else if (this.result >= 12) {
        level = 0;
      }
      if (this.level != 5) {
        if (this.assmentData.riskType == 0) {
          this.assmentData.riskMatrix = level;
        }
        this.assmentData.controlLevel = level;
      }
      this.current = 0;
      this.modalShowBig = false;
    },
    handleSpan({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0 && columnIndex === 0) {
        return [4, 1];
      }
      if (rowIndex === 1 && columnIndex === 0) {
        return [0, 0];
      }
      if (rowIndex === 2 && columnIndex === 0) {
        return [0, 0];
      }
      if (rowIndex === 3 && columnIndex === 0) {
        return [0, 0];
      }
    },
    cancel() {
      this.numl = [0, 0, 0, 0, 0, 0];
      this.nums = [0, 0, 0, 0, 0, 0];
      this.current = 0;
      this.modalShowBig = false;
    },
    pre() {
      if (this.current <= 2) {
        this.current -= 1;
      }
    },
    next() {
      if (this.current == 0) {
        let maxNum = 0;
        let neWArray = [];
        for (let i = 0; i < this.numl.length; i++) {
          let argument = this.numl[i];
          if (argument != 0) {
            neWArray.push(argument);
          }
        }
        for (let i = 0; i < neWArray.length; i++) {
          maxNum = maxNum + neWArray[i];
        }
        if (maxNum == 0 || neWArray.length == 0) {
          this.l = 0;
        } else {
          this.l = maxNum / neWArray.length;
          this.l = Math.ceil(this.l);
        }
      }
      if (this.current == 1) {
        let maxNum = 0;
        for (let i = 0; i < this.nums.length; i++) {
          let argument = this.nums[i];
          if (argument && argument > maxNum) {
            maxNum = argument;
          }
        }
        this.s = maxNum;
        this.result = this.s * this.l;
      }
      if (this.current < 2) {
        this.current += 1;
      }
    },

    showBigModal() {
      if (this.assmentData.riskType == 0) {
        this.modalShowBig = true;
      } else if (
        this.assmentData.riskType == 1 ||
        this.assmentData.riskType == 2
      ) {
        this.modalShowBig2 = true;
        this.data6 = JSON.parse(this.assmentData.content);
        for (var i = 0; i < this.data6.length; i++) {
          var data6Element = this.data6[i];
          if (!data6Element.col10) {
            this.numl2[i] = 0;
          } else {
            this.numl2[i] = data6Element.col10;
          }
          if (!data6Element.col11) {
            this.nums2[i] = 0;
          } else {
            this.nums2[i] = data6Element.col11;
          }
          this.changeNum();
        }
      }
    },
    changeControlLevel(val) {
      if (this.assmentData.riskType == 0) {
        this.assmentData.riskMatrix = val;
      }
    },
    showModal(row) {
      this.assmentData = JSON.parse(JSON.stringify(row));
      this.modalShow = true;
    },
    asyncOK() {
      this.componentsMoudel.httpRequest
        .getRequestHander("/riskclassification/update")
        .openLoad()
        .startPost(this.assmentData)
        .then(res => {
          if (res.result == "success") {
            this.$message({
              showClose: true,
              message: "评价成功",
              type: "success"
            });
            this.modalShow = false;
            this.assmentData = {};
            this.getRiskClassification(1);
          }
        });
    },
    handAdd1() {
      this.$router.push({
        path: "/processManager/addTwoCardOne"
      });
    },
    handAdd2() {
      this.$router.push({
        path: "/processManager/addTwoCardTwo"
      });
    },
    edit1(row) {
      let obj = { ...row };
      // console.log(row.alarmId)
      // return
      if (row.alarmId) {
        let arr = row.alarmId.split(",");
        let arr2 = [];
        for (let i in arr) {
          arr2.push(arr[i] * 1);
        }
        obj.alarmId = arr2;
      }
      this.$router.push({
        name: "addTwoCardOne",
        params: { key: obj }
      });
    },
    remove1(val) {
      // console.log(val)
      this.$confirm(`删除 "${val.riskName}", 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.componentsMoudel.httpRequest
            .getRequestHander("/riskclassification/delete/" + val.id)
            .openLoad()
            .startDel()
            .then(res => {
              if (this.data1.length <= 1 && this.curPageGk > 1) {
                this.curPageGk -= 1;
              }
              this.getRiskClassification(this.curPageGk);
              this.$message({
                showClose: true,
                message: "删除成功",
                type: "success"
              });
            });
        })
        .catch(() => {
          return;
        });
    },
    edit2(row) {
      this.$router.push({
        name: "addTwoCardTwo",
        params: { key: row }
      });
    },
    remove2(val) {
      // console.log(val)
      this.$confirm(`删除 "${val.harmfulName}", 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.componentsMoudel.httpRequest
            .getRequestHander("/harmfulfactorsinvestigation/delete/" + val.id)
            .openLoad()
            .startDel()
            .then(res => {
              if (this.data2.length <= 1 && this.curPagePC > 1) {
                this.curPagePC -= 1;
              }
              this.$message({
                showClose: true,
                message: "删除成功",
                type: "success"
              });
              this.getHarmfulfactors(this.curPagePC);
            });
        })
        .catch(() => {
          return;
        });
    },
    // 请求安全风险分级管控清单
    getRiskClassification(page) {
      this.curPageGk = page;
      let url =
        "/riskclassification/list_all?limit=" +
        10 +
        "&curPage=" +
        page +
        "&isPage=" +
        1;
      if (this.findName && this.findName.length > 0) {
        url =
          "/riskclassification/list_all?limit=" +
          10 +
          "&curPage=" +
          page +
          "&findName=" +
          this.findName +
          "&isPage=" +
          1;
      }
      // if(this.$route.query.id){
      //   this.queryState = true
      // }
      // 没带参数请求
      if (!this.$route.query.id) {
        this.componentsMoudel.httpRequest
          .getRequestHander(url)
          .openLoad()
          .startGet()
          .then(res => {
            this.data1 = res.body.data;
            this.total1 = res.body.cum;
          });
      } else {
        // 别的页面跳转过来，带参数请求
        let message = {
          limit: this.pageSize,
          curPage: 1,
          id: this.$route.query.id,
          riskType: this.$route.query.riskType,
          dangerAreaId: this.$route.query.dangerAreaId
        };
        jumpTwoOrder(message).then(res => {
          this.data1 = res.body.data;
          this.total1 = res.body.cum;
        });
      }
    },
    getHarmfulfactors1(val) {
      this.dangerAreaId = val;
      this.getHarmfulfactors(1);
    },
    getHarmfulfactors(page) {
      // this.curPagePC = page
      //   let url ="/harmfulfactorsinvestigation/list_all?limit=" +10 +"&curPage="+page+"&isPage="+1;
      //   if (this.dangerAreaId){
      //       url ="/harmfulfactorsinvestigation/list_all?limit=" +10 +"&curPage="+page+"&dangerAreaId="+this.dangerAreaId+"&isPage="+1;
      //   }
      //   if (this.name && this.name.length >0){
      //       url = url + "&name="+this.name;
      //   }
      //   this.componentsMoudel.httpRequest
      //       .getRequestHander(url)
      //       .openLoad()
      //       .startGet()
      //       .then((res) => {
      //           this.data2 = res.body.data;
      //           this.total2 = res.body.cum;
      //       });
      getDangerISPcList({
        limit: 10,
        curPage: page,
        dangerAreaId: this.dangerAreaId,
        name: this.name
      }).then(res => {
        this.data2 = res.body.data;
        this.total2 = res.body.cum;
      });
    }
  },
  mounted() {
    if (this.$route.query.id) {
      let message = {
        limit: this.pageSize,
        curPage: 1,
        id: this.$route.query.id,
        riskType: this.$route.query.riskType,
        dangerAreaId: this.$route.query.dangerAreaId
      };
      jumpTwoOrder(message).then(res => {
        this.data1 = res.body.data;
        this.total1 = res.body.cum;
      });
    } else {
      this.getRiskClassification(1);
      // this.getHarmfulfactors(1);
      this.getDangerArea();
      this.getMyId();
    }
  }
};
</script>

<style>
.head1 {
  position: absolute;
  top: 0px;
  left: 250px;
  width: 80%;
  height: 60px;
}
.ivu-table .myBlue {
  background-color: #2db7f5;
}
.ivu-table .myYellow {
  background-color: #ffff00;
}
.ivu-table .myRed {
  background-color: #ff0000;
}
.ivu-table .myNotRed {
  background-color: #e36c0a;
}
</style>
